function Home() {
  return (
    <section className="hero is-fullheight-with-navbar">
      <div className="hero-body">
        <div className="container">
          <p className="title is-1 has-text-centered has-text-black">
            <span role="img" className="hero-home">
              Welcome to Jordans Collections! Choose your Kicks!
              <img src="https://wallpapercave.com/wp/CkYaMKP.jpg" alt="jordan-image.jpg" width="900" height="500" />
            </span>
          </p>
        </div>
      </div>
    </section>
  )
}
export default Home